if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				this.form.querySelector("[name=id]").disabled = false;
				this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
				this.cart =
					document.querySelector("cart-notification") ||
					document.querySelector("cart-drawer");
				this.submitButton = this.querySelector('[type="submit"]');
				if (document.querySelector("cart-drawer"))
					this.submitButton.setAttribute("aria-haspopup", "dialog");

				this.hideErrors = this.dataset.hideErrors === "true";
			}

			onSubmitHandler(evt) {
				evt.preventDefault();
				if (this.submitButton.getAttribute("aria-disabled") === "true") return;

				this.handleErrorMessage();

				this.submitButton.setAttribute("aria-disabled", true);
				this.submitButton.classList.add("loading");
				if (this.querySelector(".loading-overlay__spinner")) {
					this.querySelector(".loading-overlay__spinner").classList.remove(
						"hidden"
					);
				}

				const config = fetchConfig("javascript");
				config.headers["X-Requested-With"] = "XMLHttpRequest";
				delete config.headers["Content-Type"];

				const formData = new FormData(this.form);
				if (this.cart) {
					formData.append(
						"sections",
						this.cart.getSectionsToRender().map((section) => section.id)
					);
					formData.append("sections_url", window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							publish(PUB_SUB_EVENTS.cartError, {
								source: "product-form",
								productVariantId: formData.get("id"),
								errors: response.description,
								message: response.message,
							});
							this.handleErrorMessage(response.description);

							const soldOutMessage =
								this.submitButton.querySelector(".sold-out-message");
							if (!soldOutMessage) return;
							this.submitButton.setAttribute("aria-disabled", true);
							this.submitButton.querySelector("span").classList.add("hidden");
							soldOutMessage.classList.remove("hidden");
							this.error = true;
							return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						if (!this.error)
							publish(PUB_SUB_EVENTS.cartUpdate, {
								source: "product-form",
								productVariantId: formData.get("id"),
							});
						this.error = false;
						const quickAddModal = this.closest("quick-add-modal");
						if (quickAddModal) {
							document.body.addEventListener(
								"modalClosed",
								() => {
									setTimeout(() => {
										this.cart.renderContents(response);
									});
								},
								{ once: true }
							);
							quickAddModal.hide(true);
						} else {
							this.cart.renderContents(response);
						}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove("loading");
						if (this.cart && this.cart.classList.contains("is-empty"))
							this.cart.classList.remove("is-empty");
						if (!this.error) this.submitButton.removeAttribute("aria-disabled");
						if (this.querySelector(".loading-overlay__spinner")) {
							this.querySelector(".loading-overlay__spinner").classList.add(
								"hidden"
							);
						}
					});
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;

				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						".product-form__error-message"
					);

				this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
	);
}

(function () {
	if (window.__pecQuoteCartFallbackInstalled) return;
	window.__pecQuoteCartFallbackInstalled = true;

	var originalFetch = window.fetch.bind(window);
	var nativeAddSeen = false;
	var fallbackAdding = false;

	function requestUrl(input) {
		if (typeof input === "string") return input;
		if (input && typeof input.url === "string") return input.url;
		return "";
	}

	function updateCartCount(count) {
		document
			.querySelectorAll(".pec-quote-header__cart span")
			.forEach(function (el) {
				el.textContent = String(count);
			});
	}

	function getCart() {
		return originalFetch("/cart.js", { credentials: "same-origin" }).then(
			function (res) {
				return res.json();
			}
		);
	}

	function scheduleFallback(plan) {
		if (!plan || !plan.ok || !plan.variantId || fallbackAdding) return;

		getCart()
			.then(function (beforeCart) {
				var baselineCount = Number(beforeCart && beforeCart.item_count) || 0;

				window.setTimeout(async function () {
					try {
						if (nativeAddSeen || fallbackAdding) return;

						var currentCart = await getCart();
						var currentCount = Number(currentCart && currentCart.item_count) || 0;
						if (currentCount > baselineCount) {
							updateCartCount(currentCount);
							return;
						}

						fallbackAdding = true;
						var addResponse = await originalFetch("/cart/add.js", {
							method: "POST",
							credentials: "same-origin",
							headers: { "Content-Type": "application/json" },
							body: JSON.stringify({
								items: [
									{
										id: plan.variantId,
										quantity: Number(plan.quantity) || 1,
										properties: plan.properties || {},
									},
								],
							}),
						});

						if (addResponse.ok) {
							var afterCart = await getCart();
							updateCartCount(Number(afterCart && afterCart.item_count) || 0);
						}
					} catch (error) {
						console.error("[PEC Quote] Cart fallback failed", error);
					} finally {
						fallbackAdding = false;
					}
				}, 1800);
			})
			.catch(function () {});
	}

	window.fetch = async function (input, init) {
		var url = requestUrl(input);
		var isCartAdd = /\/cart\/add(?:\.js)?/.test(url);
		if (isCartAdd && !fallbackAdding) nativeAddSeen = true;

		var response = await originalFetch(input, init);

		if (/\/apps\/opc-express-proxy2\/variant\/plan/.test(url)) {
			response.clone().json().then(scheduleFallback).catch(function () {});
		}

		return response;
	};
})();
